
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fonds-provisionsrechner",
      function () {
        return require("private-next-pages/fonds-provisionsrechner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fonds-provisionsrechner"])
      });
    }
  